export const SKUS_QUERY_STRING = Object.freeze({
  CATEGORY_NAME: "catName",
  CATEGORY_ID: "catId",
  SUB_CATEGORY_ID: "subCatId",
  COMMERCIAL_NAME: "q",
  SKU_BRANDS: "skuBrands",
  SKU_NAMES: "skuNames",
  SKU_IDS: "skuIds",
  CAR_BRANDS: "carBrands",
  CAR_MODELS: "carModels",
  CAR_TRANSMISSION_CC: "cc",
  CAR_YEAR_LIST: "carYearList",
});
